// Utilitaires images : Google Drive, miniatures WebP (Supabase Storage), placeholder.

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL as string;

/** Extrait le FILE_ID d'un lien Google Drive. */
export function extractDriveFileId(url: string): string | null {
  if (!url) return null;
  let m = url.match(/\/file\/d\/([a-zA-Z0-9_-]+)/);
  if (m) return m[1];
  m = url.match(/[?&]id=([a-zA-Z0-9_-]+)/);
  if (m) return m[1];
  return null;
}

export function isGoogleDriveUrl(url?: string | null): boolean {
  return !!url && url.includes('drive.google.com');
}

/** Convertit un lien de partage Google Drive en URL directe affichable. */
export function convertGoogleDriveUrl(url: string): string {
  const id = extractDriveFileId(url);
  if (!id) return url;
  return `https://drive.google.com/uc?export=view&id=${id}`;
}

export function isSupabaseStorageUrl(url?: string | null): boolean {
  return !!url && !!SUPABASE_URL && url.startsWith(`${SUPABASE_URL}/storage/v1/object/public/`);
}

/** Résout l'URL d'affichage : upload (Storage) prioritaire sur URL externe (convertie si Drive). */
export function resolveImageUrl(uploadedUrl?: string | null, externalUrl?: string | null): string {
  if (uploadedUrl) return uploadedUrl;
  if (externalUrl) return isGoogleDriveUrl(externalUrl) ? convertGoogleDriveUrl(externalUrl) : externalUrl;
  return '';
}

/** Miniature WebP via transformation Supabase (sinon URL telle quelle). */
export function thumb(url?: string | null, width = 700): string {
  if (!url) return '';
  if (isSupabaseStorageUrl(url)) {
    const rendered = url.replace('/storage/v1/object/public/', '/storage/v1/render/image/public/');
    const sep = rendered.includes('?') ? '&' : '?';
    return `${rendered}${sep}width=${width}&quality=75&resize=contain`;
  }
  return url;
}

export const IMG_PLACEHOLDER =
  'data:image/svg+xml;utf8,' +
  encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" width="400" height="300" viewBox="0 0 400 300">
      <rect width="400" height="300" fill="#f1f1f1"/>
      <g fill="#c4c4c4"><circle cx="186" cy="140" r="7"/>
      <path d="M162 168l20-18 14 12 18-20 24 26v4a8 8 0 0 1-8 8h-60a8 8 0 0 1-8-8z"/></g>
      <text x="200" y="210" font-family="sans-serif" font-size="13" fill="#9a9a9a" text-anchor="middle">Image indisponible</text>
    </svg>`
  );
